import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { Box } from "../../Box/index.js";
import { Typography } from "../../Typography/index.js";
import { IconButton } from "../../IconButton/index.js";
import { List, ListItem } from "../../List/index.js";
import { Icon } from "../../Icon/index.js";
const DescriptionsItem = (t0)=>{
    const $ = c(17);
    const { label, value, listItems: t1, children, flexDirection: t2, alignItems: t3, valueTextVariant: t4, iconColor, maxLength: t5, fullWidth: t6 } = t0;
    const listItems = void 0 === t1 ? false : t1;
    const flexDirection = void 0 === t2 ? "column" : t2;
    const alignItems = void 0 === t3 ? "flex-start" : t3;
    const valueTextVariant = void 0 === t4 ? "body2" : t4;
    const maxLength = void 0 === t5 ? 4 : t5;
    const fullWidth = void 0 === t6 ? false : t6;
    const [expanded, setExpanded] = useState(false);
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setExpanded(_temp);
        };
        $[0] = t7;
    } else t7 = $[0];
    const handleExpandClick = t7;
    let t8;
    if ($[1] !== label) {
        t8 = label && /*#__PURE__*/ jsx(Box, {
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "body3",
                color: "text.light.tertirary",
                children: `${label}:`
            })
        });
        $[1] = label;
        $[2] = t8;
    } else t8 = $[2];
    let t9;
    if ($[3] !== children || $[4] !== expanded || $[5] !== fullWidth || $[6] !== iconColor || $[7] !== listItems || $[8] !== maxLength || $[9] !== value || $[10] !== valueTextVariant) {
        t9 = children ? /*#__PURE__*/ jsxs(Box, {
            width: fullWidth ? "100%" : "auto",
            display: "flex",
            gap: "8",
            flexWrap: "wrap",
            alignItems: "center",
            children: [
                /*#__PURE__*/ jsx(Typography, {
                    variant: valueTextVariant,
                    color: "text.light.tertirary",
                    children: `${value}:`
                }),
                children
            ]
        }) : /*#__PURE__*/ jsxs(Box, {
            width: fullWidth ? "100%" : "auto",
            children: [
                /*#__PURE__*/ jsxs(Box, {
                    children: [
                        Array.isArray(value) && !listItems && /*#__PURE__*/ jsx(Box, {
                            display: "flex",
                            flexDirection: "column",
                            gap: "16",
                            children: (expanded ? value : value.slice(0, maxLength)).map((itemValue)=>/*#__PURE__*/ jsx(Box, {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4",
                                    children: /*#__PURE__*/ jsx(Typography, {
                                        variant: valueTextVariant,
                                        children: itemValue
                                    })
                                }, itemValue))
                        }),
                        Array.isArray(value) && listItems && /*#__PURE__*/ jsx(List, {
                            listStyleType: "disc",
                            pl: 1.6,
                            children: (expanded ? value : value.slice(0, maxLength)).map((itemValue_0, index)=>/*#__PURE__*/ jsx(ListItem, {
                                    children: /*#__PURE__*/ jsx(Box, {
                                        pt: 0 === index ? "unset" : "8",
                                        children: /*#__PURE__*/ jsx(Typography, {
                                            variant: valueTextVariant,
                                            children: itemValue_0
                                        })
                                    })
                                }, itemValue_0))
                        })
                    ]
                }),
                !Array.isArray(value) && /*#__PURE__*/ jsx(Box, {
                    children: /*#__PURE__*/ jsx(Typography, {
                        variant: valueTextVariant,
                        children: value
                    })
                }),
                /*#__PURE__*/ jsx(Box, {
                    children: Array.isArray(value) && value.length > maxLength && /*#__PURE__*/ jsx(Box, {
                        children: /*#__PURE__*/ jsx(Box, {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mt: "8",
                            children: /*#__PURE__*/ jsx(IconButton, {
                                type: "button",
                                size: "small",
                                onClick: handleExpandClick,
                                children: /*#__PURE__*/ jsx(Icon, {
                                    name: expanded ? "arrow_triangle_up" : "arrow_triangle_down",
                                    size: "16",
                                    color: iconColor
                                })
                            })
                        })
                    })
                })
            ]
        });
        $[3] = children;
        $[4] = expanded;
        $[5] = fullWidth;
        $[6] = iconColor;
        $[7] = listItems;
        $[8] = maxLength;
        $[9] = value;
        $[10] = valueTextVariant;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== alignItems || $[13] !== flexDirection || $[14] !== t8 || $[15] !== t9) {
        t10 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            flexDirection: flexDirection,
            gap: "8",
            alignItems: alignItems,
            children: [
                t8,
                t9
            ]
        });
        $[12] = alignItems;
        $[13] = flexDirection;
        $[14] = t8;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    return t10;
};
function _temp(prev) {
    return !prev;
}
export { DescriptionsItem };
